import { Component, Inject, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SavedPin } from '@models/teranet';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import { SaleInstrumentsState } from '@state/sale_instruments';
import { InstrumentsDispatch } from '@state/sale_instruments/instruments.dispatch';
import { PurchaseStates, PurchaseStateType } from '@state/utils/models';
import { Observable } from 'rxjs';
import { TestHooks } from './purchase-instrument.hooks';

export interface PurchaseInstrumentModalData {
	pin: SavedPin;
}

@UntilDestroy()
@Component({
	selector: 'app-purchase-instrument',
	templateUrl: './purchase-instrument.component.html',
	standalone: false,
})
export class PurchaseInstrumentComponent implements OnInit {
	testHooks = TestHooks;
	public instrumentNumber: string;
	public pin: SavedPin;
	public error = null;
	public purchasing = false;
	public purchasedInstrument = null;

	@Select(SaleInstrumentsState.getInstrumentPurchaseState)
	instrumentPurchaseState$: Observable<PurchaseStates>;

	constructor(
		private dialog: MatDialogRef<PurchaseInstrumentComponent>,
		@Inject(MAT_DIALOG_DATA) public data: PurchaseInstrumentModalData,
		private instrumentsDispatch: InstrumentsDispatch,
	) {
		this.pin = data.pin;
	}

	ngOnInit(): void {
		this.instrumentPurchaseState$
			.pipe(untilDestroyed(this))
			.subscribe((purchaseState) => {
				if (
					purchaseState[this.instrumentNumber]?.state ===
					PurchaseStateType.SUCCESSFUL
				) {
					this.dialog.close();
				} else if (
					purchaseState[this.instrumentNumber]?.state ===
					PurchaseStateType.ERROR
				) {
					this.error = purchaseState[this.instrumentNumber]?.error;
					this.purchasing = false;
				}
			});
	}

	purchaseInstrument(form: NgForm) {
		this.error = null;
		if (form.valid) {
			this.purchasing = true;
			this.purchasedInstrument = this.instrumentNumber;
			this.instrumentsDispatch.purchaseInstrumentDocuments(this.pin.pin, [
				this.instrumentNumber,
			]);
		}
	}
}
